import { endpoints } from 'modules/endpoints'
import { createBasicManagers } from 'modules/utils/helpers/createBasicManagers'
import { octopusApiClient } from 'modules/utils/httpClient'
import {
  TargetListRequestFilter,
  TargetListRequestSorting,
  RetailerTarget,
  RetailerTargetCreateDTO,
  TargetUpdateDTO,
} from '../common/types'

export default createBasicManagers<
  TargetListRequestFilter,
  TargetListRequestSorting,
  RetailerTarget,
  RetailerTargetCreateDTO,
  TargetUpdateDTO
>(endpoints.retailerTarget, octopusApiClient)
